
export const VocabButtons = {
    "update" : ["Actualizar", "Update",],
    "continue": ["Continuar", "Continue"],
    "start": ["Comenzar", "Let's Start"],
    "next" : ["→ Siguiente", "→ Next",],
    "download" : ["Descarga", "Download",],
    "back" : ["← Atrás", "← Back",],
    "submit" : ["Enviar", "Submit",],
    "save" : ["Guardar", "Save",],
    "send" : ["Enviar", "Send",],
    "saving" : ["Guardando", "Saving",],
    "save_changes" : ["Guardar cambios", "Save changes",],
    "cancel": ["Cancelar", "Cancel"],
    "yes" : ["Si", "Yes",],
    "no" : ["No", "No",],
    "remove": ["Eliminar", "Remove"],
    "search": ["Buscar", "Search"],
    "add": ["Añadir", "Add"],
    "close": ["Cerrar", "Close"],
    "help": ["Ayuda", "Help"],
    "ascendent": ["Asc", "Asc"],
    "descendent": ["Desc", "Desc"],
    "creating": ["Creando...", "Creating..."],
  }
    